export function Suspense() {
  return (
    <div className="h-full w-full bg-white">
      <div className="h-full w-full z-[100] bg-brand-black/50 fixed top-0 left-0 flex items-center justify-center">
        <div className="relative flex justify-center items-center"></div>
      </div>
    </div>
  );
}
